import { render, staticRenderFns } from "./OrderInfoForm.vue?vue&type=template&id=47a101b2&"
import script from "./OrderInfoForm.vue?vue&type=script&lang=js&"
export * from "./OrderInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports